import React from 'react'
import PropTypes from 'prop-types'
import numeral from 'numeral'

import UserAvatar from 'Pods/Shared/UserAvatar/UserAvatar'

function TopDesignersTab({ data }) {
  return (
    <div>
      {data.map((item, index) => {
        return (
          <div className="designers-list__item" key={item.user.url}>
            <small>{`${index + 1}. `}</small>
            <a href={item.user.url} target="_blank" className="link--primary-dark">
              <UserAvatar
                className="avatar--with-name"
                size="small"
                img={item.user.thumb_url}
                userName={item.user.name}
              />
              <small>{item.user.name}</small>
            </a>
            <span className="u-float-right item__designer-score">
              {`+ ${numeral(item.user.score).format('0')}`}
            </span>
          </div>
        )
      })}
    </div>
  )
}

TopDesignersTab.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string.isRequired,
      user: PropTypes.shape({
        name: PropTypes.string.isRequired,
        score: PropTypes.number.isRequired,
        thumb_url: PropTypes.string,
        url: PropTypes.string.isRequired,
      }).isRequired,
    })
  ).isRequired,
}

export default TopDesignersTab
